angular.module('clients')
    .component('clientSnapshot', {
        bindings: {
            item: '<',
            showErrorOnNull: '<',
            labelKey: '@'
        },
        template: `
            <div ng-if="$ctrl.item || $ctrl.showErrorOnNull === true" style="margin-bottom: 10px">
                <div class="form-group" ng-if="$ctrl.labelKey"><label>{{ $ctrl.labelKey | translate }}</label></div>
                <div class="client-lead-card">
                    <div class="text-danger bold text-center" ng-if="!$ctrl.item">brak kontrahenta</div>

                    <client-list-format ng-if="$ctrl.item.client" clients="[$ctrl.item.client]"></client-list-format>
                    <div ng-if="$ctrl.item.fullName" class="bold">{{$ctrl.item.fullName}}</div>
                    <div ng-if="$ctrl.item.address || $ctrl.item.postcode || $ctrl.item.city">
                        <span ng-if="$ctrl.item.address">{{$ctrl.item.address}}</span>
                        <span ng-if="$ctrl.item.address && ($ctrl.item.postcode || $ctrl.item.city)">,&nbsp;</span>
                        <span ng-if="$ctrl.item.postcode">{{$ctrl.item.postcode}}</span>
                        <span ng-if="$ctrl.item.postcode && $ctrl.item.city">&nbsp;</span>
                        <span ng-if="$ctrl.item.city">{{$ctrl.item.city}}</span>
                    </div>

                    <div ng-if="$ctrl.item.taxNo"><span class="bold">NIP:&nbsp;</span>{{$ctrl.item.taxNo}}</div>
                </div>
            </div>
        `
    })
